<template>
    <div class="row text-left">
        <div class="col-12">
            <div class="row">
                <div class="col-2">
                    <select v-model="sport" class="form-control form-control-sm rounded">
                        <option v-for="s in sportList" :value="s.id">{{ s.name }}</option>
                    </select>
                </div>
                <div class="col-2">
                    <div class="form-group">
                        <input class="form-control" v-model="name" :placeholder="t.template_name" type="text" required>
                    </div>
                </div>
                <div class="col-8 text-right">
                    <a href="javascript:;" @click="deactivateAll" class="mr-5 mb-2 btn">
                        Deactivate All Markets
                    </a>
                    <a href="javascript:;" @click="activateAll" class="mr-5 mb-2 btn btn-warning">
                        Activate All Markets
                    </a>
                    <a href="javascript:;" @click="resetIt" class="mr-5 mb-2 btn btn-danger">
                        Reset
                    </a>
                    <a @click="saveTheTemplate()" href="javascript:;" class="mr-2 mb-2 btn btn-success">
                        Save
                    </a>
                </div>
            </div>
        </div>
        <div class="col-4 mt-4" v-for="v in list">
            <div class="element-box el-tablo trend-in-corner padded bold-label p-0">
                <div class="row">
                    <div class="col-9">
                       <div class="p-4">
                         {{ v.name }}
                       </div>
                    </div>
                    <div class="col-3">
                        <div class="p-3">
                            <div id="toggles" v-tooltip="'Enable/Unable the market'">
                                <input type="checkbox" :id="'e_'+v.id" :name="'e_'+v.id" @click="MarketStatus(v)" value="1" class="ios-toggle" :checked="v.active">
                                <label :for="'e_'+v.id" class="checkbox-label"></label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-tooltip="'(-)Decrease / Increase(+) Outcome ODD'">
                        <form :style="'--min: 1; --max: 10; --val:'+ v.margin +'; border-radius: 5px;'" class="ios-slider p-3">
                            <input v-model="v.margin" type="range" min="1" max="10" value="5" list="l">
                            <datalist id="l">
                                <option label="min" value="1"></option>
                                <option label="max" value="10"></option>
                            </datalist>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="custom-template" :duration="5000" :width="500" animation-name="v-fade-left" position="top center" />
    </div>
</template>
  
<script>
import feed from '@/mixins/feed.js'
export default {
    name: 'templateConfig',
    mixins: [feed],
    props: ['id', 'name'],
    data () {
        return {
            t: this.$root.t,
            list: [],
            sport: 1,
            sportList: [],
        }
    },
    mounted () {

    },
    watch: {
        'id' (o,n) {
            this.getMarketList(this.sport, o).then(response => {
                this.list = response.body
            })
        },
        'sport' (o,n) {
            this.getMarketList(o, this.id).then(response => {
                this.list = response.body
            })
        }
    },
    mounted() {
        this.getSport()
    },
    methods: {
        getSport() {
            this.fetchSport().then(response => {
                this.sportList = response.body.result
            })
        },
        fetchMarkets () {
            this.getMarketList(this.sport, this.id).then(response => {
                this.list = response.body
            })
        },
        activateAll(){
            this.list.forEach((v,i) => {
                v.active = true
            })
        },
        deactivateAll(){
            this.list.forEach((v,i) => {
                v.active = false
            })
        },
        MarketStatus (t){
            t.active = (t.active) ? false : true
        },
        saveTheTemplate(){

            var payload = new Array()
            this.list.forEach(element => {
                element.margin = parseInt(element.margin)
                payload.push(element)
            });

            this.saveTemplate(this.id, payload, this.sport, this.name).then(response => {
                this.$notify({
                    group: 'custom-template',
                    text: this.t.processing.success,
                    type: 'success',
                    duration: 1000,
                    speed: 1000,
                    data: {}
                })
            })
        },
        resetIt() {
            this.resetTemplate(this.id).then(response => {
                this.$notify({
                    group: 'custom-template',
                    text: this.t.processing.success,
                    type: 'success',
                    duration: 1000,
                    speed: 1000,
                    data: {}
                })
                this.fetchMarkets()
            })
        },
        changeModalBackground (){

        }
    }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>  


// WEBPACK FOOTER //
// src/components/feed/templateConfig.vue